import "./App.css"
import { useState, useEffect } from "react"
import RouterConfig from "./routes/RouterConfig"
import { initializeKeycloak } from "./config/keycloakConfig"
import { SnackbarProvider } from "./context/SnackbarProvider"

function App() {
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    initializeKeycloak(() => setIsInitialized(true)).catch((error) => {
      console.error("Failed to initialize Keycloak:", error)
    })
  }, [])

  if (!isInitialized) {
    return (
      <div className="flex justify-center items-center h-dvh bg-[var(--bg-loader)]">
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #e0e0e0",
              borderTop: "4px solid #2074AE",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 16px",
            }}
          />
          <span style={{ color: "#666", fontSize: "14px" }}>
            Authenticating...
          </span>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    )
  }

  return (
    <SnackbarProvider>
      <RouterConfig />
    </SnackbarProvider>
  )
}

export default App
